const MailSvg = ({ size = 8 }) => (
  <svg
    className={` size-${size}`}
    viewBox="0 0 21 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 3V13.5C20.25 14.7426 19.2426 15.75 18 15.75H3C1.75736 15.75 0.75 14.7426 0.75 13.5V3M20.25 3C20.25 1.75736 19.2426 0.75 18 0.75H3C1.75736 0.75 0.75 1.75736 0.75 3M20.25 3V3.24271C20.25 4.02405 19.8447 4.74945 19.1792 5.15894L11.6792 9.77433C10.9561 10.2194 10.0439 10.2194 9.32078 9.77433L1.82078 5.15894C1.15535 4.74945 0.75 4.02405 0.75 3.24271V3"
      stroke="var(--primary-500)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MailSvg;
